import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getOrderDetails,getGeofenceByFleetId, getFleetConfigByFleetId } from "../API";
import {findNorthWestAndSouthEast} from "../utils"
import Header from "./Header";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

function OrderCancel() {
  const { orderID } = useParams();
  const [orderDetails, setOrderDetails] = useState();
  const [fleetConfig, setFleetConfig] = useState(JSON.parse(localStorage.getItem("fleetConfig") || "{}"));
  const [amountRefundDuration , setAmountRefundDuration] = useState(fleetConfig?.amountRefundDuration || process.env.REACT_APP_AMOUNT_REFUND_TIME)

  const loaderContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "10vh",
  };

  const loaderStyle = {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderTop: "4px solid #000",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "spin 1s linear infinite",
  };

  const keyframesAnimation = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  useEffect(() => {
    getOrderDetails(orderID)
      .then((res) => {
        getGeofenceByFleetId(res?.data?.data?.fleetId).then((res)=>{
          const maxBoundCordinates = findNorthWestAndSouthEast(res.data.geofence)
          console.log(maxBoundCordinates)
        })
        // localStorage.setItem("name", res?.data?.data?.name);
        // localStorage.setItem("email", res?.data?.data?.email);
        // localStorage.setItem("phone", res?.data?.data?.phone);
        // localStorage.setItem("pin", res?.data?.data?.pin);
        // if (res.data?.data?.statusCode === 9) {
        //   history(`/orderdelivered/${orderID}`);
        // }
        // if ([10, 14].includes(res.data?.data?.statusCode)) {
        //   history(`/ordercancel/${orderID}`);
        // }
        setOrderDetails(res.data.data);
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  }, [orderID]);
  useEffect (() => {
    const fetchFleetConfig = async () => {
      try {
        const response = await getFleetConfigByFleetId(process.env.REACT_APP_FLEETID);
        const data = response?.data?.data
        localStorage.setItem("fleetConfig", JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchFleetConfig();
  },[orderID])

  const formattedDate = (date) => {
    const orderDate = new Date(date);
    const yyyy = orderDate.getFullYear();
    let mm = orderDate.getMonth() + 1; // Months start at 0!
    let dd = orderDate.getDate();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return mm + "-" + dd + "-" + yyyy;
  };

  return (
    <>
      <div className="MainWhole-wrapper-container">
        {/* {console.log('orderIdorderId',orderData)} */}
        <Header />
        <div className="Congratulation-Main-wrapper">
          <div className="OrderCancel_page_thankYou_div_wrapper">
            <h3>Order Status</h3>
          </div>
          <div className="OrderDelivered_page_tick_div">
            <img src="/assets/images/noun-cross-2310549.svg" alt="" />
          </div>
          <div>
            <h3 className="OrderCancel_page_h3"> Cancelled</h3>
          </div>
          <Timeline position="alternate" style={{ marginTop: "0px" }}>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot variant="outlined" className="timeline_dot_grey" />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent></TimelineContent>
            </TimelineItem>
            <div className="OrderCancel_page_content_div">
              <h4>Order ID </h4>
              <p> {orderID}</p>
            </div>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent></TimelineContent>
            </TimelineItem>
            <div className="OrderCancel_page_content_div">
              <h4>Date </h4>
              {orderDetails ? (
                <p>{formattedDate(orderDetails?.createdAt)}</p>
              ) : (
                <div style={loaderContainerStyle}>
                  <style>{keyframesAnimation}</style>
                  <div style={loaderStyle}></div>
                </div>
              )}
            </div>
          </Timeline>
        </div>
      </div>
      {!!Number(process.env.REACT_APP_SHOWREFUND)&&
      <div className="fixed z-20 flex flex-col gap-2">
        <div className="fixed flex bottom-[0rem] items-center justify-around w-full h-16 rounded-md px-3 bg-[#DADADA] ">
          <div className="CancelOrder_page_refund_p_tag">
            <p>
              {amountRefundDuration&&`Any refund if applicable will be processed in ${amountRefundDuration}`}
            </p>
          </div>
        </div>
        {/* <div className="fixed flex bottom-0 items-center w-full h-[5rem] px-4 py-4 bg-white">
          <button className="w-full h-10 !bg-[#02B7D4] font-bold text-base rounded-md">
            <a
              href="https://ck85l93ctgh.typeform.com/to/BBvgB1HV"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center w-full h-full px-4 text-base text-white no-underline max-sm:text-sm"
            >
              Please let us know about your experience
            </a>
          </button>
        </div> */}
      </div>
    }
      {/* <Footer orderdelivered={true}/> */}
    </>
  );
}

export default OrderCancel;
